module.exports = __webpack_public_path__ + "static/media/fullcircle.b497ceaf.png";